import { getFileType, MediaItem } from "@/shared/lib";
import React from "react";
import { X, ArrowRepeat, Play } from "react-bootstrap-icons";

interface AttachedFilesPreviewProps {
  files: File[];
  currentIndex: number|null;
  onRemove: (index: number) => void;
  onReplace: (index: number, newFile: File) => void;
  openMediaModal: (media: MediaItem[], index: number) => void;
}

export const AttachedFilesPreview: React.FC<AttachedFilesPreviewProps> = ({
  files,
  currentIndex,
  onRemove,
  onReplace,
  openMediaModal,
}) => {
  // const getMediaType = (file: File): "image" | "video" | "other" =>
  //   file.type.startsWith("image/")
  //     ? "image"
  //     : file.type.startsWith("video/")
  //     ? "video"
  //     : "other";

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        position: "relative",
        gap: 4,
        padding: "4px 8px",
        border: "1px solid #ddd",
        borderRadius: 24,
        background: "#f8f9fa",
        marginBottom: 8,
      }}
    >
      <X
        size={18}
        color="white"
        style={{
          cursor: "pointer",
          position: "absolute",
          top: 10,
          right: 10,
          background: "rgba(0,0,0,0.6)",
          borderRadius: "50%",
          padding: 2,
        }}
        onClick={(e) => {
          e.stopPropagation();
          onRemove(-1);
        }}
      />

      {files.map((file, i) => {
        const url = URL.createObjectURL(file);
        const isImage = file.type.startsWith("image/");
        const isVideo = file.type.startsWith("video/");
        const isSelected = currentIndex === i;

        return (
          <div
            key={i}
            style={{
              position: "relative",
              width: 80,
              height: 80,
              borderRadius: "1rem",
              overflow: "hidden",
              border: isSelected
                ? "2px solid #0d6efd" 
                : "1px solid #ccc",
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              boxShadow: isSelected ? "0 0 0 1px rgba(13,110,253,0.3)" : "none", 
            }}
            onClick={() => {
              const media: MediaItem[] = files.map((f) => ({
                url: URL.createObjectURL(f),
                type: getFileType(f),
              }));
              openMediaModal(media, i);
            }}
          >
            {isImage ? (
              <img
                src={url}
                alt={file.name}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                onLoad={() => URL.revokeObjectURL(url)}
              />
            ) : isVideo ? (
              <>
                <video
                  src={url}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                  muted
                  onLoadedData={() => URL.revokeObjectURL(url)}
                />
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(0,0,0,0.3)",
                  }}
                >
                  <Play size={28} color="white" />
                </div>
              </>
            ) : (
              <span
                style={{
                  fontSize: 10,
                  padding: 2,
                  textAlign: "center",
                }}
              >
                {file.name}
              </span>
            )}

            {/* Кнопки удаления и замены */}
            <div
              style={{
                position: "absolute",
                top: 4,
                right: 4,
                display: "flex",
                gap: 4,
              }}
            >
              <X
                size={18}
                color="white"
                style={{
                  cursor: "pointer",
                  background: "rgba(0,0,0,0.6)",
                  borderRadius: "50%",
                  padding: 2,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove(i);
                }}
              />
              <ArrowRepeat
                size={18}
                color="white"
                style={{
                  cursor: "pointer",
                  background: "rgba(0,0,0,0.6)",
                  borderRadius: "50%",
                  padding: 2,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  const input = document.createElement("input");
                  input.type = "file";
                  input.accept = isImage
                    ? "image/*"
                    : isVideo
                    ? "video/*"
                    : "*";
                  input.onchange = (ev: any) => {
                    const newFile = ev.target.files?.[0];
                    if (newFile) {
                      onReplace(i, newFile);
                    }
                  };
                  input.click();
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};